import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import useGameStore from '../store/gameStore';

const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:4000';

export function useSocket() {
  const socketRef = useRef(null);
  const {
    setSocket, setConnected, setSession,
    onBetPlaced, onStepResult, onCashOutResult,
    gameId, sessionId, playerId, mode,
  } = useGameStore();

  useEffect(() => {
    if (!sessionId) return;

    const socket = io(SERVER_URL, { transports: ['websocket'] });
    socketRef.current = socket;
    setSocket(socket);

    socket.on('connect', () => {
      setConnected(true);
      socket.emit('join_game', { gameId, sessionId, playerId, mode });
    });

    socket.on('disconnect', () => setConnected(false));

    socket.on('session_ready', (data) => {
      setSession(data);
    });

    socket.on('bet_placed',     (data) => onBetPlaced(data));
    socket.on('step_result',    (data) => onStepResult(data));
    socket.on('cash_out_result',(data) => onCashOutResult(data));

    socket.on('error', ({ message }) => {
      console.error('[Socket error]', message);
      useGameStore.getState().setGameState('idle');
    });

    return () => { socket.disconnect(); };
    // eslint-disable-next-line
  }, [sessionId]);

  const placeBet = (amount, difficulty) => {
    socketRef.current?.emit('place_bet', { amount, difficulty });
    useGameStore.getState().setGameState('waiting_for_server');
  };

  const takeStep = () => {
    socketRef.current?.emit('take_step');
    useGameStore.getState().setGameState('waiting_for_server');
  };

  const cashOut = () => {
    socketRef.current?.emit('cash_out');
    useGameStore.getState().setGameState('waiting_for_server');
  };

  return { placeBet, takeStep, cashOut };
}
